import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { InAppBrowser, InAppBrowserOptions } from '@ionic-native/in-app-browser/ngx';
import * as JWT from 'jsonwebtoken';
import { HttpClient } from '@angular/common/http';
import { Storage } from '@ionic/storage';
import { AlertController } from 'ionic-angular';

import { AppConfigProvider } from '../../providers/app-config/app-config';
import { SlideContentPage } from '../slidecontent/slidecontent';
import { SettingPage } from '../setting/setting';

import { ShariahServiceProvider } from '../../providers/shariah-service/shariah-service';

/**
 * Generated class for the CartPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-cart',
  templateUrl: 'cart.html'
})

export class CartPage {
  cart: any[];
  cartTotal: number;
  subportfolios: any[];
  user_id: Number;
  cart_id: Number;
  token: string;
  name: string;
  phone: string;
  user:any;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private http: HttpClient,
    private appConfig: AppConfigProvider,
    private storage: Storage,
    private iab: InAppBrowser,
    private alertCtrl: AlertController,
    private shariahService: ShariahServiceProvider
  ) {
    this.cart      = [];
    this.cartTotal = 0;

    this.getCartDetail();
  }

  async ionViewWillEnter() {
    this.user_id = await this.storage.get('user_id');
    this.token   = await this.storage.get('token');

    this.shariahService.getUser(this.user_id, this.token).subscribe((data: any) => {
      this.user = data.result;
    });
  }

  // async ngOnInit() {
  //   this.user_id = await this.storage.get('user_id');
  //   this.token   = await this.storage.get('token');
  // }

  async openBrowser() {
    if (this.user.name && this.user.phone) {
      const payload = {
        user_id: this.user_id,
        items: this.cart
      }

      const token = await JWT.sign(payload, this.appConfig.appKey(), { expiresIn: '24h'});

      let url     = `${ this.appConfig.apiUrl() }index.php/cart/payment/${ token }`;

      const options: InAppBrowserOptions = {
        location: 'yes',
        zoom: 'no',
      }

      const browser = await this.iab.create(url, '_blank', options);

      // browser.on('loadstop').subscribe(event => {
      //   browser.executeScript({ code: "returnCartId();" })
      //     .then(data => console.log(data))
      //     .catch(err => console.log(err));

      //   // Start an interval
      //   // var loop = setInterval(() => browser.executeScript({ code: "localStorage.getItem('cart_id')" }), 100);
      // });

      browser.on('exit').subscribe(() => {
        this.storage.remove('cart');
        this.navCtrl.pop();
      })
    } else {
      this.alert('Update Full Name and Contact Number', 'It seems like you have not updated your name/phone number. Please go to the settings page to update your information to make payment.', () => {
        this.navCtrl.push(SettingPage);
      }, () => {
        console.log('NO');
      });
    }
  }

  async removeItem(sub_id) {
    for(var i = 0; i < this.cart.length; i++){
        if (parseInt(this.cart[i]) == sub_id) {
        this.cart.splice(i, 1);

        await this.storage.set('cart', JSON.stringify(this.cart));
        await this.getCartDetail();
      }
    }
  }

  openSlide(row) {
    // console.log(row);
    this.navCtrl.push(SlideContentPage, {
      subportfolio_id: row.id,
      img: row.img,
      price: row.price,
      title: row.title
    });
  }

  getCartDetail () {
    this.storage.get('cart').then((v) => {
      if (v) {
        this.cart = JSON.parse(v);

        this.http
          .post(this.appConfig.apiUrl() + 'index.php/api/cart/get_detail', {
            token: 'token',
            subportfolio_ids: this.cart,
            app_key: this.appConfig.appKey()
          })
          .subscribe(
            (res: any) => {
              if (res) {
                this.subportfolios = res.details;
                console.log(this.subportfolios);
                for (let key in this.subportfolios) {
                  this.cartTotal += parseInt(this.subportfolios[key].price);
                }
              }
            },
            err => {
              console.log('error');
            }
          );
      }
    });
  }

  alert(title, message, yesHandler, noHandler) {
    const confirm = this.alertCtrl.create({
      title: title,
      message: message,
      buttons: [
        { text: 'No', handler: () => noHandler() },
        { text: 'Yes', handler: () => yesHandler() }
      ]
    });
    confirm.present();
  }

  createBill() {
    // let url = 'blob/api/endpoint?parameter1=somevalue&parameter2=anothervalue';
    // console.log('URL: ' + url);
    // let headers: Headers = new Headers();
    // let data = {
    //   collection_id: '6vxnnh6y',
    //   description:
    //     'Lorem ipsum dolor sit amet consectetur adipisicing elit. Perspiciatis, sapiente!',
    //   email: 'email@email.com',
    //   name: 'Tester 1',
    //   mobile: '0123456789',
    //   amount: '40000',
    //   callback_url: 'http://localhost'
    // };
    // let httpOptions = {
    //   headers: {
    //     Authorization:
    //       'Basic YmY3YzYyNzYtYjkyMy00OTc5LTg0ZTMtNmUwM2RjZmUzZmE5Og=='
    //   }
    // };
    // this.http.post('/api', data, httpOptions).subscribe(
    //   (res: any) => {
    //     let data = res;
    //     console.log(data);
    //   },
    //   err => {
    //     console.log('Error request' + JSON.stringify(err));
    //   }
    // );
    // this.http.get('/api/collections', httpOptions);
  }
}



// WEBPACK FOOTER //
// ./src/pages/cart/cart.ts